import { render, staticRenderFns } from "./tabSubBill.vue?vue&type=template&id=2bc4bdd8&"
import script from "./tabSubBill.vue?vue&type=script&lang=js&"
export * from "./tabSubBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bc4bdd8')) {
      api.createRecord('2bc4bdd8', component.options)
    } else {
      api.reload('2bc4bdd8', component.options)
    }
    module.hot.accept("./tabSubBill.vue?vue&type=template&id=2bc4bdd8&", function () {
      api.rerender('2bc4bdd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/tabs/tabSubBill.vue"
export default component.exports